import { h } from "preact";

import IconProps from "./IconProps";

function IconPin({ color, width, height, class: cssClass }: IconProps) {
    return (
        <svg width={width}
            height={height}
            class={cssClass}
            viewBox="0 0 24 24">
            <path fill={color}
                d="M4.751 8.364c1.002-1.002 2.631-1.002 3.633 0l7.252 7.252c1.002 1.002 1.002 2.631 0 3.633-1.002 1.001-2.631 1.001-3.633 0l-3.26-3.263-3.862 3.863c-.201.201-.528.201-.73 0-.186-.186-.2-.479-.043-.681l.043-.05 3.862-3.862-3.26-3.263c-.96-.954-1.002-2.492-.127-3.495zm2.903.73c-.598-.598-1.574-.598-2.174.001-.597.593-.597 1.573.001 2.167l7.252 7.257c.599.598 1.575.598 2.173 0 .599-.599.599-1.575 0-2.173zm8.606-4.432l.093.088 2.897 2.897c.97.97 1 2.53.088 3.535l-.088.092-2.897 2.897c-.202.202-.529.202-.73 0-.186-.186-.2-.478-.043-.68l.043-.05 2.897-2.897c.573-.573.596-1.493.069-2.093l-.069-.074-2.897-2.897c-.573-.573-1.493-.596-2.094-.069l-.073.069-1.043 1.042 2.79 2.79c.202.202.202.529 0 .73-.185.186-.478.2-.68.043l-.05-.043-2.79-2.791-1.124 1.126c-.202.202-.529.202-.73 0-.186-.186-.2-.479-.043-.681l.043-.049 2.897-2.897c.97-.97 2.529-1 3.534-.088z"/>
        </svg>
    );
}

IconPin.defaultProps = {
    color: "var(--teflon)",
    width: 24,
    height: 24
};

export default IconPin;
